export const Footer = () => (
  <footer className="bg-[#EFEAE1] pt-20 pb-8 overflow-hidden" data-testid="main-footer">
    <div className="px-5 lg:px-10 flex flex-wrap items-center justify-between gap-3 mb-14">
      <div className="flex gap-2">
        <a href="https://www.linkedin.com/in/nayan-verma-007" target="_blank" rel="noopener noreferrer" className="pill" data-testid="footer-linkedin-link">LinkedIn</a>
      </div>
      <a href="/admin" className="text-xs text-[#4A453F]/50 hover:text-[#121110] transition-colors duration-300" data-testid="footer-admin-link">
        Private study
      </a>
    </div>

    <h2 className="px-5 lg:px-10 font-giant leading-[0.85] text-[#121110] text-[14.5vw] lg:text-[15.5vw] whitespace-nowrap flex items-end gap-[2vw]" aria-hidden="true">
      NAYAN
      <span className="inline-block overflow-hidden rounded-2xl mb-[1vw]" style={{ height: "10.5vw", width: "8vw", minWidth: "56px", minHeight: "72px" }}>
        <img
          src="https://customer-assets-jai6qajn.emergentagent.net/job_nayan-magic/artifacts/5ab5jyxm_Single_picture_of_this-1779351362852.png"
          alt=""
          className="w-full h-full object-cover contrast-105"
          style={{ objectPosition: "50% 12%" }}
        />
      </span>
      <span>
        V<span className="font-swash text-[#A8512E] text-[12.5vw]">e</span>RMA
      </span>
    </h2>

    <div className="px-5 lg:px-10 mt-10 flex flex-wrap items-center justify-between gap-3 text-sm text-[#4A453F]">
      <span>{new Date().getFullYear()} © Nayan Verma</span>
      <span className="font-swash text-lg text-[#A8512E]">slow introvert, magic results</span>
    </div>
  </footer>
);

export default Footer;
